class Drawer {
	constructor() {
		this.drawerIsOpen = false;
		this.init = this.init.bind(this);
		this.clickDrawerBtn = this.clickDrawerBtn.bind(this);
		this.closeDrawer = this.closeDrawer.bind(this);
		this.toggleDrawerSubmenu = this.toggleDrawerSubmenu.bind(this);
	}

	init() {
		this.drawerBtn = document.querySelector('.drawer-btn');
		if (this.drawerBtn) {
			this.drawerBtn.addEventListener('click', this.clickDrawerBtn);
			document.addEventListener('click', this.closeDrawer);
		}
		this.drawerSubmenu = document.querySelectorAll('.drawer-has-submenu');
		if (this.drawerSubmenu) {
			for (let i = this.drawerSubmenu.length - 1; i >= 0; i -= 1) {
				this.drawerSubmenu[i].addEventListener(
					'click',
					this.toggleDrawerSubmenu
				);
			}
		}
		this.overlay = document.querySelector('.overlay');
		this.drawerWrapper = document.querySelector('.drawer-wrapper');
		this.toolbarLogo = document.querySelector('.toolbar-logo img');
	}

	clickDrawerBtn() {
		this.overlay.classList.toggle('is-hidden');
		this.toolbarLogo.classList.toggle('is-hidden');
		this.drawerWrapper.classList.toggle('drawer-open');
		this.drawerBtn.classList.toggle('toolbar-open');
		this.drawerIsOpen = !this.drawerIsOpen;
	}

	closeDrawer(e) {
		const el = e.target;
		if (
			el.classList.contains('drawer-btn') ||
			el.classList.contains('drawer-has-submenu')
		) {
			return;
		}
		this.overlay.classList.add('is-hidden');
		this.toolbarLogo.classList.remove('is-hidden');
		this.drawerWrapper.classList.remove('drawer-open');
		this.drawerIsOpen = false;
	}

	toggleDrawerSubmenu(evt) {
		const el = evt.target;
		const submenu = el.parentNode.querySelector('ul');
		submenu.classList.toggle('is-hidden');
		el.classList.toggle('open');
		this.drawerIsOpen = true;
	}
}

export default Drawer;
